import styled from '@emotion/styled'
import { css } from '@emotion/react'

import { Button, ButtonProps } from 'components/inputs/Button/Button'
import { ImagePreview } from 'components/data/ImagePreview/ImagePreview'
import { ContentSection } from 'components/data/ContentSection/ContentSection'
import { Checkbox } from 'components/inputs/Checkbox/Checkbox'
import { Link } from 'components/inputs/Link/Link'

const RootContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) => theme.spacing(3)}px;
  max-width: 800px;
`

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
`

const InfoSection = styled(ContentSection)`
  margin-top: ${({ theme }) => theme.spacing(2.5)}px;
  flex: 1;
`

const HelpersContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
`

const RowContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  grid-column-gap: 20px;
`

const FlexColumnContainer = styled.div`
  flex: 1;
`

interface ExitButtonProps extends ButtonProps {
  $isMobile?: boolean
}

const EditButton = styled((props: ExitButtonProps) => (
  <Button {...props} />
), { shouldForwardProp: (prop) => prop !== '$isMobile' })`
  ${({ theme, $isMobile }) => css`
    width: auto;
    ${$isMobile ? css`
      margin-left: ${theme.spacing(2.5)}px;
    ` : css`
      position: absolute;
      bottom: 50px;
      right: 50px;
      z-index: 1;
    `}
  `}
`

const StyledImagePreview = styled(ImagePreview)`
  max-width: 250px;
  height: 150px;
`

const DifficultySliderContainer = styled.div`
  padding: ${({ theme }) => theme.spacing(1, 5)};
`

const CheckboxSection = styled.div`
  margin-top: ${({ theme }) => theme.spacing(2)}px;
`

const StyledCheckbox = styled(Checkbox)`
  margin: 5px 0;
`

const LabelContainer = styled.div`
  ${({ theme }) => `
    gap: ${theme.spacing(1)}px;
  `}
  display: flex;
  flex-wrap: wrap;
`

const DisplayRootContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) => theme.spacing(3)}px;
  max-width: 100%;
  height: 100%;
`

const DisplayContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  max-height: 95%;
`

const DisplayButton = styled(Button)`
  margin: ${({ theme }) => theme.spacing(1, 2, 1, 0)};
  width: 215px;
  font-size: 15px;
  white-space: nowrap;
`

const DownloadLink = styled(Link)`
  width: 100%;
  height: 100%;
  text-decoration: inherit;
  color: inherit;
  :hover,
  :focus {
    opacity: inherit;
  }
`

const ImageObject = styled.picture`
  height: fit-content;
  width: fit-content;
  max-width: 100%;
  max-height: 100%;
`

const Img = styled.img`
  width: 100%;
  height: 100%;
`

const VideoObject = styled.video`
  height: fit-content;
  width: fit-content;
  max-width: 100%;
  max-height: 100%;
`

const AudioObject = styled.audio`
  height: 60px;
  width: 500px;
  max-width: 100%;
  max-height: 100%;
`

const PdfObject = styled.object`
  height: 100%;
  width: 100%;
`

const MetadataHeader = styled.div`
  margin-top: ${({ theme }) => theme.spacing(2)}px;
`

export {
  RootContainer,
  HeaderContainer,
  ContentContainer,
  InfoSection,
  HelpersContainer,
  EditButton,
  StyledImagePreview as ImagePreview,
  RowContainer,
  FlexColumnContainer,
  DifficultySliderContainer,
  CheckboxSection,
  StyledCheckbox as Checkbox,
  DisplayRootContainer,
  DisplayContentContainer,
  DisplayButton,
  DownloadLink,
  ImageObject,
  Img,
  VideoObject,
  AudioObject,
  PdfObject,
  MetadataHeader,
  LabelContainer,
}
